function mapController(
  buttonDiv: HTMLDivElement,
  map: { setZoom: (arg0: number) => void; getZoom: () => number },
  maps: {
    event: {
      addDomListener: (arg0: HTMLButtonElement, arg1: string, arg2: { (): void; (): void }) => void
    }
  },
  styles: { readonly [x: string]: string },
) {
  const buttonZoomAddition = document.createElement('button')
  const buttonZoomSubtraction = document.createElement('button')
  const imgAddition = document.createElement('img')
  const imgSubtraction = document.createElement('img')

  buttonZoomAddition.setAttribute('type', 'button')
  buttonZoomSubtraction.setAttribute('type', 'button')
  imgAddition.setAttribute(
    'src',
    `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/img_on_zoom.png`,
  )
  imgSubtraction.setAttribute(
    'src',
    `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/img_off_zoom.png`,
  )
  buttonDiv.classList.add(`${styles.c_zoom_bottom}`)
  buttonZoomAddition.style.marginTop = '300%'
  buttonZoomAddition.appendChild(imgAddition)
  buttonZoomSubtraction.appendChild(imgSubtraction)
  buttonDiv.appendChild(buttonZoomAddition)
  buttonDiv.appendChild(buttonZoomSubtraction)

  maps.event.addDomListener(buttonZoomAddition, 'click', function () {
    map.setZoom(map.getZoom() + 1)
  })

  maps.event.addDomListener(buttonZoomSubtraction, 'click', function () {
    map.setZoom(map.getZoom() - 1)
  })
}

export default mapController
